// extracted by mini-css-extract-plugin
export default {"parties__container":"Parties_parties__container__BOqDk","parties-overflow-wrap":"Parties_parties-overflow-wrap__nNCMS"};